import React from "react";
const BLUE = "#1271EB";
const BLUE_LIGHT = "#4D95F0";

export default function BrandLogo({ size = 36 }) {
  return (
    <div
      className="rounded-xl shadow-lg"
      style={{
        width: size,
        height: size,
        background: `linear-gradient(145deg, ${BLUE} 0%, ${BLUE_LIGHT} 100%)`,
        boxShadow: `0 8px 24px ${BLUE}22`,
        display: "grid",
        placeItems: "center",
      }}
      aria-hidden
    >
      <svg
        width={size * 0.6}
        height={size * 0.6}
        viewBox="0 0 24 24"
        fill="none"
      >
        <path
          d="M4 13l1.4-4.2A2 2 0 0 1 7.3 7h9.4a2 2 0 0 1 1.9 1.8L20 13"
          stroke="white"
          strokeWidth="1.8"
          strokeLinecap="round"
        />
        <path
          d="M3 13h18v4a1 1 0 0 1-1 1h-1.5a1 1 0 0 1-1-1v-1H6.5v1a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1v-4z"
          fill="white"
        />
        <circle cx="7.5" cy="15.5" r="1.25" fill={BLUE} />
        <circle cx="16.5" cy="15.5" r="1.25" fill={BLUE} />
      </svg>
    </div>
  );
}
